import APICall from "../utils/APICall"

export class BudgetServices{
    static listBudget = async (page, pageLimit, search,from , to, budgetMonth,budgetStatus ) => {
return await APICall(`/api/Budget/admin/list-all-budget?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&budgetMonth=${budgetMonth}&budgetStatus=${budgetStatus}`, "GET");
    }
}